import React from 'react';

const Preview = ({ formData, getIconUrl, currentStep }) => {
	const currentStepData = currentStep === 1 ? formData.step1 : formData.step2;
	// For Step 1, show Yes/No buttons. For Step 2, show Coupon/Done buttons

	return (
		<div className="w-full">
			<h3 className="text-xl font-semibold text-gray-800 mb-4 text-center">
				Preview
			</h3>

			{/* Simulated device frame */}
			<div className="w-full max-w-xs mx-auto bg-white overflow-hidden border border-gray-200">
				{/* Screen content */}
				<div className="text-black min-h-[300px] flex flex-col justify-between">
					<div className="text-center">
						<img
							src={
								getIconUrl() ||
								'https://d3myyafggcycom.cloudfront.net/assets/app-welcome.png'
							}
							alt="App Icon"
							className="w-full h-full"
						/>
						<div className="px-6 pt-6">
							<h4 className="text-2xl font-bold mb-2">
								{currentStepData.title}
							</h4>
							<p className="text-sm opacity-90">
								{currentStepData.description}
							</p>
							{currentStep === 2 && formData.step2.couponCode && (
								<div className="mt-4">
									<div className="flex flex-col items-center justify-center mt-1 space-y-4">
										<span className="px-3 py-1 bg-gray-100 rounded-md text-lg font-semibold border border-gray-400 border-dashed">
											{formData.step2.couponCode}
										</span>
										<button
											className="px-6 py-2 rounded-md text-sm"
											style={{
												backgroundColor:
													formData.advancedSettings.couponCodeButton
														.backgroundColor,
												color:
													formData.advancedSettings.couponCodeButton.textColor,
											}}
										>
											{formData.advancedSettings.couponCodeButton.text}
										</button>
									</div>
								</div>
							)}
						</div>
					</div>

					{/* Buttons based on step */}
					<div className="mt-6 flex gap-3 justify-center px-6 pb-6">
						{currentStep === 1 && (
							<div className="flex flex-col gap-3">
								<button
									className="px-4 py-2 rounded-lg text-sm font-medium w-36"
									style={{
										backgroundColor:
											formData.advancedSettings.yesButton.backgroundColor,
										color: formData.advancedSettings.yesButton.textColor,
									}}
								>
									{formData.advancedSettings.yesButton.text}
								</button>
								<button
									className="px-4 py-2 rounded-lg text-sm font-medium w-36"
									style={{
										backgroundColor:
											formData.advancedSettings.noButton.backgroundColor,
										color: formData.advancedSettings.noButton.textColor,
									}}
								>
									{formData.advancedSettings.noButton.text}
								</button>
							</div>
						)}
						{currentStep === 2 && (
							<button
								className="w-full px-6 py-3 rounded-lg text-md font-semibold"
								style={{
									backgroundColor:
										formData.advancedSettings.doneButton.backgroundColor,
									color: formData.advancedSettings.doneButton.textColor,
								}}
							>
								{formData.advancedSettings.doneButton.text}
							</button>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Preview;
